import { hi } from 'date-fns/locale';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableComposeExperienceAppReferences from './tableComposeExperienceAppReferences';

export default {
  title: 'General values',
  attributeName: 'generalValues',
  idAttribute: 'id',
  saveIdSessionNameAs: 'composeExperienceId',
  fields: [
 {
      attributeName: 'id',
      helpText: 'Id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Id',
      placeholder: 'Write a name...',
      default: '',
      hidden:true
    },
    {
      attributeName: 'name',
      helpText: 'Name for the composed experience',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Write a name...',
      default: '',
    },
    {
      attributeName: 'sendToYBAI',
      label: 'Send video to YBAI for analysis',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      buttonText:"Send to YBAI",
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Send video to YBAI for analysis.',
      // redirectUrl:'lives',
      actionUrl:'sendToYBAIComposeExperience',
      sessionParams: ['composeExperienceId'],
      isEditId:true,
      visibleWhen: [{"field":"id","value":"not-null"}],
      formConfig:
        {
          title: 'Send Video to YBAI',
          description:'In this action you are going to comunicate to YBAI information about a video preview and also some context about it for processing.',
          attributeName: 'sendToYBAIForm',
          fields: [
            {
              attributeName: 'videoPreviewUrl',
              helpText: 'Select a valid video preview to send (mp4).',
              type: FormInputTypes.SELECT,
              label: 'Video Url Preview',
              placeholder: 'Please enter a valid video',
              multiple: false,
              url: 'listValidVideosYBAI/composeExperienceId',
              // url: 'listValidOrigins',
              validateUrl:'sendVideoToYBAIValidate/composeExperienceId',
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'id',
              fieldName:'url',
              asyncSelect: true,
              options:[],
              sessionParams: ['composeExperienceId'],
            },
           {
              attributeName: 'context',
              multiline:true,
              helpText: 'Context ofthe video.',
              type: FormInputTypes.TEXT_INPUT.TEXT,
              label: 'Context',
              placeholder: 'Video context to be sent...',
              
              
            },
      
          ]
        }
    }, 
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
     {
      attributeName: 'reProcessFile',
      label: 'Reprocess MPD to get preview',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.NEW,
      buttonText:"Reprocess MPD to get preview",
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Send video to VOD Backend to get the preview file.',
      actionUrl:'reprocessMPDComposeExperience',
      sessionParams: ['composeExperienceId'],
      isEditId:true,
      visibleWhen: [{"field":"id","value":"not-null"}],
      refreshIfOk:true,
      formConfig:
        {
          title: 'Reprocess MPD File and Extract Preview',
          description:'In this action you are going to comunicate to VOD Backend to reprocess the MPD file and extract a preview.',
          attributeName: 'reProcessMPDForm',
          fields: [
            {
              attributeName: 'videoMPDUrl',
              helpText: 'Select a valid MPD to extract the preview.',
              type: FormInputTypes.SELECT,
              label: 'Video Url (MPD)',
              placeholder: 'Please enter a valid video',
              multiple: false,
              url: 'listValidVideosReprocess/composeExperienceId',
              // url: 'listValidOrigins',
              validateUrl:'reprocessVideoValidate/composeExperienceId',
              emptyValue:true,
              default:'(Empty)', //default value to empty option
              fieldValue:'id',
              fieldName:'url',
              asyncSelect: true,
              options:[],
              sessionParams: ['composeExperienceId'],

            },
      
          ]
        }
    }, 
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appReferences',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableComposeExperienceAppReferences

    },
  ],
};
